import injector from 'vue-inject';
import LocaleService from '@/services/localeService.js';

injector.service('localeService', LocaleService);



// WEBPACK FOOTER //
// ./src/services.js